import { useSessionAuth } from '@/context/Auth';
import { createOrderRefund } from '@/infrastructure/api/order';
import { Refund } from '@/infrastructure/domain/order';
import { UseMutationResult, useMutation } from '@tanstack/react-query';

export const useCreateOrderRefund = (): UseMutationResult<
  Refund,
  Error,
  { orderId: string; refund: Partial<Refund> },
  unknown
> | null => {
  const { token } = useSessionAuth();

  return useMutation({
    mutationFn: ({
      orderId,
      refund,
    }: {
      orderId: string;
      refund: Partial<Refund>;
    }) => createOrderRefund(token!, orderId, refund),
  });
};
